<template>
  <div>
    <br /><br />
    <div class="import-form">
      <h2>Importar Archivo CSV</h2>
      <form @submit.prevent="handleSubmit">
        <label for="file">Seleccione un archivo:</label>
        <input
          type="file"
          id="file"
          accept=".csv, .xlsx"
          @change="handleFileChange"
        />

        <div class="flex justify-between items-center mt-4">
          <button
            type="submit"
            :disabled="!selectedFile || subidaExitosa" 
            class="btn bg-blue"
          >
            Subir Archivo
          </button>

          <button
            type="button"
            @click="handleCancel"
            :disabled="!selectedFile && vehiculos.length === 0"
            class="btn bg-red"
          >
            Cancelar Carga
          </button>
        </div>
      </form>
      <div v-if="message" class="message">{{ message }}</div>
    </div>
    <div>
      <h3>PLANTILLA DEL ARCHIVO</h3>
    </div>

    <DataTable
      :columns="columns"
      :data="vehiculos"
      :options="options"
      class="display nowrap"
      style="width: 100%"
    />

    <div class="table-layaout">
      <div id="reporte">
        <table class="table-auto w-full mt-6 border">
          <thead>
            <tr>
              <th>TOTAL FILAS</th>
              <th>REGISTROS VALIDOS</th>
              <th>REGISTROS INVALIDOS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">{{ totalFilas }}</td>
              <td class="text-center">{{ registrosValidos }}</td>
              <td class="text-center">{{ registrosInvalidos }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Botón Procesar -->
    <div class="table-layaout">
      <button :disabled="!puedeProcesar">
        <i class="fa-solid fa-square-arrow-up-right"></i> Procesar
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GLOBAL from "../../Global.js";
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net";
import Buttons from "datatables.net-buttons";
import ButtonsHtml5 from "datatables.net-buttons/js/buttons.html5";
export default {
  components: { DataTable },
  data() {
    return {
      selectedFile: null,
      message: "",
      person: null,
      vehiculos: [],
      subidaExitosa: false, // <- Nueva propiedad
      columns: [
        { title: "ibutton", data: "ibutton" },
        { title: "placa", data: "placa" },
        { title: "vin", data: "vin" },
        { title: "propietario_codigo", data: "propietario_codigo" },
        { title: "propietario_nombre", data: "propietario_nombre" },
        { title: "vehiculo_marca", data: "vehiculo_marca" },
        { title: "vehiculo_modelo", data: "vehiculo_modelo" },
        { title: "vehiculo_potencia", data: "vehiculo_potencia" },
        { title: "vehiculo_servicio", data: "vehiculo_servicio" },
        { title: "fecha_certificacion", data: "fecha_certificacion" },
        { title: "fecha_proxima_revision", data: "fecha_proxima_revision" },
        { title: "mensaje", data: "mensaje" },
      ],
      options: {
        ...GLOBAL.TABLE_OPTIONS,
        createdRow: function (row, data, dataIndex) {
          const vueInstance = this;
        }.bind(this),
      },
    };
  },
  computed: {
    totalFilas() {
      return this.vehiculos.length;
    },
    registrosValidos() {
      return this.vehiculos.filter((v) => v.mensaje === "OK").length;
    },
    registrosInvalidos() {
      return this.vehiculos.filter((v) => v.mensaje !== "OK").length;
    },
    puedeProcesar() {
      return this.vehiculos.length > 0 && this.registrosInvalidos === 0;
    },
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.message = `Archivo seleccionado: ${file.name}`;
      } else {
        this.selectedFile = null;
        this.message = "";
      }
    },
    async handleSubmit() {
      if (!this.selectedFile) {
        this.message = "Por favor, seleccione un archivo primero.";
        return;
      }

      const formData = new FormData();
      formData.append("file", this.selectedFile);

      try {
        var url1 = GLOBAL.API_IMPORT_FILE_CVS;
        const response = await axios.post(url1, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Basic " + this.person.token,
            Environment: this.person.empresas,
          },
        });
        console.log(response.data);
        this.vehiculos = response.data;
        this.subidaExitosa = true;
      } catch (error) {
        console.error(error);
        this.message = "Error de conexión con el servidor.";
      }
    },
    handleCancel() {
      this.selectedFile = null;
      this.vehiculos = [];
      this.message = "";
      this.subidaExitosa = false;

      // También puedes resetear el input file manualmente:
      const fileInput = document.getElementById("file");
      if (fileInput) {
        fileInput.value = ""; // Limpia el input de tipo file
      }
    },
  },
};
</script>

<style scoped>
.import-form {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}

button {
  padding: 10px 20px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.message {
  margin-top: 10px;
  color: #333;
}

.table-file {
  font-size: 13px;
}

/* Contenedor centrado */
.boton_layaout {
  width: 500px;
  text-align: right;
  margin: auto;
  background-color: #e5e7eb;
  margin-top: 20px;
  padding: 10px;
}

.table-layaout {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
}

.table-auto {
  border-collapse: collapse;
  width: 100%;
  max-width: 500px; /* Ancho máximo de 500px */
  margin: 0 auto; /* Centrado horizontal */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
}

.table-auto th,
.table-auto td {
  border: 1px solid #e5e7eb; /* gray-200 */
  padding: 0.75rem;
  text-align: right;
}

.table-auto th {
  background-color: #f9fafb; /* gray-50 */
  font-weight: 600;
  text-align: center;
  color: #111827; /* gray-900 */
}

.table-auto td {
  background-color: #ffffff;
  color: #374151; /* gray-700 */
}

.table-auto tbody tr:nth-child(even) {
  background-color: #f3f4f6; /* gray-100 */
}

.table-auto tbody tr:hover {
  background-color: #e0f2fe; /* blue-100 */
  transition: background-color 0.3s ease;
}

/* Alineación de la primera columna (hora) al centro */
.table-auto td:first-child,
.table-auto th:first-child {
  text-align: center;
}

/* Alineación de números a la derecha para las columnas restantes */
.table-auto td:not(:first-child),
.table-auto th:not(:first-child) {
  text-align: right;
}
</style>
